<app-modal [id]="modalId" [maskClose]="false">
  <aside class="modal confirm-modal">
    <div class="modal-body">
      <div class="header">
        <div class="button regular close" (click)="cancel()"><span class="icon">&#x00D7;</span></div>
      </div>
      <div class="content">
        <div class="membership-banner">
          @if (user?.memberRole?.roleAccess === 2) {
            <img src="../../../assets/img/interstitial-modal/gold-membership.png" class="interstitial-banner" alt="Gold membership banner">
          }
          @if (user?.memberRole?.roleAccess !== 2) {
            <img src="../../../assets/img/interstitial-modal/free-membership.png" class="interstitial-banner" alt="Free membership banner">
          }
        </div>
        @if (text) {
          <p class="title">{{text}}</p>
        }
        @if (subText) {
          <p class="subtitle">{{subText}}</p>
        }
      </div>
      <div class="footer">
        <button class="button regular solid-green" (click)="upgrade()">{{confirmButtonText}}</button>
        <p class="no-thanks-btn" (click)="cancel()">No Thanks</p>
      </div>
    </div>
  </aside>
  <div class="confirm-modal-background"></div>
</app-modal>
